const headerStyle = { backgroundColor: "#FFDB8A", color: "#333", fontWeight: "bold" };
const dataStyle = { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" };

export const colunasVendasCrm = [
  {
    dataField: "base",
    text: "Base",
    headerAlign: "center",
    align: "center",
    headerStyle,
  },
  {
    dataField: "vlrTotal",
    text: "Total Vendido",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    formatter: (cell) =>
      parseFloat(cell || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      }),
  },
  {
    dataField: "totalPedidos",
    text: "Qtd. Pedidos",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
  },
  {
    dataField: "totalClientes",
    text: "Qtd. Clientes",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
  },
  {
    dataField: "ticketMedio",
    text: "Ticket Médio",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    formatter: (cell) =>
      parseFloat(cell || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      }),
  },
  {
    dataField: "margemPct",
    text: "Margem %",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    formatter: (cell) =>
      parseFloat(cell || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "%",
  },
  {
    dataField: "representatividadePct",
    text: "Rpr. %",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    formatter: (cell) =>
      parseFloat(cell || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "%",
  },
];
